import { type VariantProps } from 'class-variance-authority';
import * as React from 'react';
import { cn } from '../../utils/cn';
import { badgeVariants } from './badge-variants';

export type BadgeProps = React.HTMLAttributes<HTMLDivElement> & VariantProps<typeof badgeVariants>;

export const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(
  ({ className, variant, shape = 'rectangle', ...props }, ref) => {
    return <div ref={ref} className={cn(badgeVariants({ variant, shape }), className)} {...props} />;
  },
);

Badge.displayName = 'Badge';
